import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const busService = {};

// List Bus
busService.listBus = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    // "id",
    // "name",
    // "phone_number",
    // "address",
    // "ward_code",
    // "district_code",
    // "province_code",
    // "description",
    // "maker_id",
    // "maker_date",
    // "maker.id",
    // "maker.display_name",
    // "checker_id",
    // "checker_date",
    // "checker.id",
    // "checker.display_name",
    // "record_status",
    // "tenant_code",
    // "ward_name",
    // "district_name",
    // "province_name",
    // "hub_id",
  ];

  return fetchV2({
    url: `${env.API_MSP}/buses`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-maker_date",
      keywords: params.keywords || "",
      expand: params.expand || "maker,checker,hub",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

// Create Bus
busService.createBus = data => {
  return fetchV2({
    url: `${env.API_MSP}/buses`,
    method: "post",
    data: {
      ...data,
    },
  });
};

// Detail Bus
busService.detailBus = ({
  busId,
  params = { expand: undefined, fields: undefined },
}) => {
  return fetchV2({
    url: `${env.API_MSP}/buses/${busId}`,
    method: "get",
    params: {
      ...params,
      expand: params.expand || undefined,
      fields: params.fields || undefined,
    },
  });
};

// Update Bus
busService.updateBus = ({ busId = undefined, data = {} }) => {
  return fetchV2({
    url: `${env.API_MSP}/buses/${busId}`,
    method: "put",
    data: {
      ...data,
    },
  });
};

export default busService;
